import React from "react";
import PropTypes from "prop-types";
import TypografyStyled from "./Typografy.Style";

const Typografy = (props) => {
  return <TypografyStyled {...props} />;
};

Typografy.defaultProps = {
  textSize: "md",
  textVariant: "2",
  textType: "body",
  as: "span",
  reset: {},
};

Typografy.propTypes = {
  textSize: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  textVariant: PropTypes.oneOf([null, "1", "2"]),
  textType: PropTypes.oneOf([
    "body",
    "headline",
    "lead",
    "caption",
    "button",
    "link",
  ]),
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  reset: PropTypes.instanceOf(Object),
};

export default Typografy;
